import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './lifestyle.component.scss';
import Slider from '../slider/slider.component';
var Lifestyle = /** @class */ (function (_super) {
    tslib_1.__extends(Lifestyle, _super);
    function Lifestyle(element) {
        return _super.call(this, element) || this;
    }
    Lifestyle.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 3,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.6,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 2.4,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    Lifestyle.prototype.bindEvents = function () { };
    return Lifestyle;
}(Base));
export { Lifestyle };



//////////////////
// WEBPACK FOOTER
// ./components/lifestyle/lifestyle.component.ts
// module id = 394
// module chunks = 0